import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E03 — DARD. Le contre au camping.
 *
 *  Tout shmup finit par produire un coin sûr. Le joueur le trouve en deux
 *  parties, s'y installe, et le jeu cesse d'être un jeu de déplacement pour
 *  devenir un jeu de cadence de tir. Aucun réglage de projectile ne corrige
 *  ça : un rideau plus dense rend simplement le coin plus précieux.
 *
 *  Le Dard corrige ça parce qu'il ne tire pas. Il VIENT. Un coin ne protège de
 *  rien face à quelque chose qui se déplace vers lui, et le joueur redécouvre
 *  en une seconde que sa position est un choix révocable.
 *
 *  ── Ce qu'il enseigne ──
 *  Qu'une menace peut être un CORPS. Le joueur apprend à traiter un ennemi
 *  comme un projectile qu'on peut abattre — 60 PV, il tombe en trois volées de
 *  Vulcan — ou comme un projectile qu'on esquive, s'il a mieux à faire de son
 *  temps de tir. Cette petite arbitrage-là, répété, est ce qui distingue un
 *  joueur qui vise d'un joueur qui priorise.
 *
 *  ── Pourquoi la pause compte plus que le piqué ──
 *  Le piqué à 720 u/s est trop rapide pour être esquivé en réaction : il se
 *  joue en anticipation, et l'anticipation demande un signal. C'est la pause
 *  qui est ce signal. Un Dard qui plongerait sans s'arrêter serait exactement
 *  aussi rapide et deviendrait injuste — la vitesse n'est jamais le problème,
 *  l'absence de préavis l'est toujours.
 *
 *  ── Ce qu'il n'est pas ──
 *  Il n'est PAS l'ennemi qu'on introduit seul pour l'enseigner. Sa leçon
 *  s'apprend en une occurrence ; sa valeur est d'arriver au milieu d'autre
 *  chose, quand le joueur a déjà décidé où se tenir. Le placer dans une vague
 *  calme le rend pédagogique et inutile. */
export default defineEnemy({
  id: 'dard',
  rank: Rank.Popcorn,
  hp: 60,
  visualRadius: 18,
  score: 90,
  telegraph: 0.7,
  drops: 1,
  /* `hold` court depuis l'APPARITION, pas depuis l'arrivée à la station : la
     descente d'approche en consomme environ 1,2 à 1,7 s selon la dispersion
     verticale du spawn, ce qui laisse une pause de 0,6 à 1,1 s — les « 0,8 s
     d'attente » du plan, avec la respiration qui empêche deux Dards d'un même
     groupe de plonger à l'unisson. L'altitude de départ du piqué, elle, est
     exactement 470 à chaque fois : 850 u au-dessus du joueur, soit 1,2 s de vol.

     ⚠️ Ne pas descendre `holdY` sous ~350 : le piqué deviendrait trop court
     pour être lu, et l'ennemi passerait de « anti-camping » à « injuste ». */
  motion: { kind: Motion.Dive, speed: 720, holdY: 470, hold: 2.3 },
});
